import { ICreateMacroPayload, IUpdateMacroPayload } from "store/entities/macros/interfaces";

import { BaseApi } from "../base";

export default class MacroApi extends BaseApi {
  protected readonly prefix = "macros";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get("");

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (params: ICreateMacroPayload) =>
    this.post("", {
      ...(params.name && { name: params.name }),
      ...(params.description && { description: params.description }),
      ...(params.actions && { actions: params.actions }),
      ...(params.teamIds && { teamIDs: params.teamIds }),
      shared: !!params.shared,
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (id: string, payload: IUpdateMacroPayload) =>
    this.patch(id, {
      ...(payload.name && { name: payload.name }),
      ...(payload.description && { description: payload.description }),
      ...(payload.actions && { actions: payload.actions }),
      ...(payload.teamIds && { teamIDs: payload.teamIds }),
      shared: !!payload.shared,
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  remove = (id: string) => this.delete(id);
}
